import React from "react";
import styled from "styled-components";
import Spacer from "./blocks/Spacer";
import { H2 } from "./typography";
import Icon from "./Icon";

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Grid = styled.div`
  display: flex;
  padding-top: 2rem;
  ${props => props.theme.media.tablet`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  `};
`;

export default ({ benefits = { list: [] } }) =>
  <Section>
    <H2>
      {benefits.title}
    </H2>
    <Grid>
      {benefits.icons.map(benefit =>
        <Icon
          src={benefit.src}
          tag={benefit.tag}
          description={benefit.description}
        />
      )}
    </Grid>
  </Section>;



// WEBPACK FOOTER //
// ./src/components/IconGrid.js